import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
export const Container = /*#__PURE__*/_styled(forwardRef(function IllustrationContainer({
  children,
  title,
  titleId,
  ...restProps
}, ref) {
  return _jsxs("svg", {
    viewBox: "0 0 360 360",
    ...restProps,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    role: "img",
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? _jsx("title", {
      id: titleId,
      children: title
    }) : null, children]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1ghvxf40"
} : {
  target: "e1ghvxf40",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "xarao1",
  styles: "display:block;flex-shrink:0;user-select:none"
} : {
  name: "xarao1",
  styles: "display:block;flex-shrink:0;user-select:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLSSIsImZpbGUiOiJDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmV4cG9ydCBjb25zdCBDb250YWluZXIgPSBzdHlsZWQoZm9yd2FyZFJlZihmdW5jdGlvbiBJbGx1c3RyYXRpb25Db250YWluZXIoeyBjaGlsZHJlbiwgdGl0bGUsIHRpdGxlSWQsIC4uLnJlc3RQcm9wcyB9LCByZWYpIHtcbiAgICByZXR1cm4gKF9qc3hzKFwic3ZnXCIsIHsgdmlld0JveDogXCIwIDAgMzYwIDM2MFwiLCAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCB4bWxuczogXCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiLCBmb2N1c2FibGU6IGZhbHNlLCByb2xlOiBcImltZ1wiLCBcImFyaWEtaGlkZGVuXCI6ICF0aXRsZSwgXCJhcmlhLWxhYmVsbGVkYnlcIjogdGl0bGVJZCwgY2hpbGRyZW46IFt0aXRsZSA/IF9qc3goXCJ0aXRsZVwiLCB7IGlkOiB0aXRsZUlkLCBjaGlsZHJlbjogdGl0bGUgfSkgOiBudWxsLCBjaGlsZHJlbl0gfSkpO1xufSkpIGBcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZsZXgtc2hyaW5rOiAwO1xuICB1c2VyLXNlbGVjdDogbm9uZTtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db250YWluZXIuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});